import { environment } from '../../../environments/environment';

const api = `${environment.apiUrl}/api`;

export const API_MAP = {
  home: `${api}/home`,
  shared: (lang?: string) => `${api}${lang ? '/' + lang : ''}/shared`,
  sharedRegisterNewsletter: `${api}/shared/registerNewsletter`,
  rechaptchaUrl: 'https://www.google.com/recaptcha/api.js?render=',
  contentPages: `${api}/ContentPages/`,
  article: `${api}/Article/`,
  internalDepartment: `${api}/InternalDepartment/`,
  laboratoryTestSearch: `${api}/LaboratoryTest/search`,
  laboratoryTest: (id: string) =>
    `${api}/LaboratoryTest/${id}`,
  laboratoryFilters: (path: string) =>
    `${api}/LaboratoryTest/getFilters/${path}`,
  doctor: `${api}/Doctors/`,
  doctorSelection: `${api}/DoctorSelection/`,
  getDoctorsClinicsReesult: `${api}/DoctorSelection/getDoctorsClinicsReesult`,
  event: `${api}/Events/`,
  globalSearchPage: `${api}/GlobalSearch/`,
  globalSearchFilters: (path: string) => `${api}/GlobalSearch/pageTypes/${path}`,
  globalSearch: `${api}/GlobalSearch`,
  hospital: `${api}/Hospital/`,
  cancerWizardAnswerDataOptionList: `${api}/Hospital/getCancerAnswerDataOptionsList`,
  jobSearch: `${api}/Jobs/search`,
  jobs: (id: string) => `${api}/Jobs/${id}`,
  jobsFilters: (path: string) => `${api}/Jobs/getFilters${path}`,
  locations: `${api}/locations/`,
  hotelPage: `${api}/Hotel/`,
  transparency: `${api}/Transparency/`,
  about: `${api}/About/`,
  forms: `${api}/Forms/`,
  uploadFile: `${api}/Forms/upload-file`,
  sendAppointmentForm: `${api}/AppointmentBookingForm`,
  healthCity: `${api}/HealthCity/`,
  lobby: `${api}/LobbyPage/`,
  informationSearch: `${api}/Information/search`
  //-----------------------------------------------
};
